import { FileSpreadsheet, FileText, Image, X } from "lucide-react"

interface FilePreviewProps {
  files: File[]
  onRemove: (index: number) => void
}

const EXT_ICONS: Record<string, { icon: typeof FileText; color: string }> = {
  xlsx: { icon: FileSpreadsheet, color: "text-green-600" },
  pptx: { icon: FileText, color: "text-orange-600" },
  docx: { icon: FileText, color: "text-blue-600" },
  pdf: { icon: FileText, color: "text-red-600" },
  csv: { icon: FileSpreadsheet, color: "text-green-600" },
  png: { icon: Image, color: "text-purple-600" },
  jpg: { icon: Image, color: "text-purple-600" },
  jpeg: { icon: Image, color: "text-purple-600" },
  gif: { icon: Image, color: "text-purple-600" },
  webp: { icon: Image, color: "text-purple-600" },
}

function getFileIcon(filename: string) {
  const ext = filename.split(".").pop()?.toLowerCase() || ""
  return EXT_ICONS[ext] || { icon: FileText, color: "text-gray-600" }
}

function formatFileSize(bytes: number): string {
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}

export function FilePreview({ files, onRemove }: FilePreviewProps) {
  if (files.length === 0) return null

  return (
    <div className="flex flex-wrap gap-2 px-3 pb-2">
      {files.map((file, index) => {
        const { icon: Icon, color } = getFileIcon(file.name)
        return (
          <div
            key={`${file.name}-${index}`}
            className="flex items-center gap-1.5 bg-gray-100 rounded-md px-2 py-1 text-sm"
          >
            <Icon size={14} className={color} />
            <span className="truncate max-w-[150px] text-gray-700">{file.name}</span>
            <span className="text-gray-400 text-xs">{formatFileSize(file.size)}</span>
            <button
              type="button"
              onClick={() => onRemove(index)}
              className="p-0.5 text-gray-400 hover:text-red-500 rounded transition-colors"
            >
              <X size={14} />
            </button>
          </div>
        )
      })}
    </div>
  )
}
